export const gasPriceMinimumABI = [
    {
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'adjustmentSpeed', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'AdjustmentSpeedSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            {
                name: 'baseFeeOpCodeActivationBlock',
                internalType: 'uint256',
                type: 'uint256',
                indexed: false,
            },
        ],
        name: 'BaseFeeOpCodeActivationBlockSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'gasPriceMinimumFloor', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'GasPriceMinimumFloorSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'gasPriceMinimum', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'GasPriceMinimumUpdated',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address', indexed: true }],
        name: 'RegistrySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'targetDensity', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'TargetDensitySet',
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registry',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address' }],
        name: 'setRegistry',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: '_registryAddress', internalType: 'address', type: 'address' },
            { name: '_gasPriceMinimumFloor', internalType: 'uint256', type: 'uint256' },
            { name: '_targetDensity', internalType: 'uint256', type: 'uint256' },
            { name: '_adjustmentSpeed', internalType: 'uint256', type: 'uint256' },
            { name: '_baseFeeOpCodeActivationBlock', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'initialize',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_baseFeeOpCodeActivationBlock', internalType: 'uint256', type: 'uint256' }],
        name: 'setBaseFeeOpCodeActivationBlock',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'blockGasTotal', internalType: 'uint256', type: 'uint256' },
            { name: 'blockGasLimit', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'updateGasPriceMinimum',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'tokenAddress', internalType: 'address', type: 'address' }],
        name: 'getGasPriceMinimum',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_adjustmentSpeed', internalType: 'uint256', type: 'uint256' }],
        name: 'setAdjustmentSpeed',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_targetDensity', internalType: 'uint256', type: 'uint256' }],
        name: 'setTargetDensity',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_gasPriceMinimumFloor', internalType: 'uint256', type: 'uint256' }],
        name: 'setGasPriceMinimumFloor',
        outputs: [],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'gasPriceMinimum',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'blockGasTotal', internalType: 'uint256', type: 'uint256' },
            { name: 'blockGasLimit', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'getUpdatedGasPriceMinimum',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'gasPriceMinimumFloor',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'targetDensity',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'adjustmentSpeed',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'baseFeeOpCodeActivationBlock',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
];
